function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useCallback, useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { setUIVisibilityState } from "../../actions";
import { useDispatch, useSelector } from "../../store";
import { CONTRAST_CLASSES, FONT_CLASSES, getBackgroundOption, getContrast, getFontSize, getAnimationOption, getLetterSpacing, getWordSpacing, getLineSpacing, updateBackgroundOption, updateContrast, updateFontSize, updateAnimationOption, updateWordSpacing, updateLetterSpacing, updateLineSpacing } from "../../utils/accessibility";
import { useCBookTheme } from "../../hooks";
import eventBus from "../../utils/eventBus";
import ColorModeSwitcher from "./ColorModeSwitcher";
import ClassSwitcher from "./ClassSwitcher";
import Shortcut from "./Shortcut";
import { applyColorMode, COLOR_MODES, getColorMode, updateAndApplyColorMode } from "../../utils/colorMode";
import UIModal from "../ui/UIModal";
var AccessibilityToolbar = function(param) {
    var intl = param.intl;
    var dispatch = useDispatch();
    var _useState = _slicedToArray(useState(getFontSize()), 2), currFontSize = _useState[0], setCurrFontSize = _useState[1];
    var _useState1 = _slicedToArray(useState(getContrast()), 2), currContrast = _useState1[0], setCurrContrast = _useState1[1];
    var _useState2 = _slicedToArray(useState(getBackgroundOption()), 2), currBgOption = _useState2[0], setCurrBgOption = _useState2[1];
    var _useState3 = _slicedToArray(useState(getColorMode()), 2), currColorMode = _useState3[0], setColorMode = _useState3[1];
    var _useState4 = _slicedToArray(useState(getAnimationOption()), 2), currAnimationOption = _useState4[0], setCurrAnimationOption = _useState4[1];
    var _useState5 = _slicedToArray(useState(getLetterSpacing()), 2), currLetterSpacing = _useState5[0], setCurrLetterSpacing = _useState5[1];
    var _useState6 = _slicedToArray(useState(getWordSpacing()), 2), currWordSpacing = _useState6[0], setCurrWordSpacing = _useState6[1];
    var _useState7 = _slicedToArray(useState(getLineSpacing()), 2), currLineSpacing = _useState7[0], setCurrLineSpacing = _useState7[1];
    useEffect(function() {
        // Needed to add the initial classes to the body.
        updateFontSize(currFontSize);
        updateContrast(currContrast);
        updateBackgroundOption(currBgOption);
        updateLetterSpacing(currLetterSpacing);
        updateWordSpacing(currWordSpacing);
        updateLineSpacing(currLineSpacing);
        updateAnimationOption(currAnimationOption);
    }, []);
    useEffect(function() {
        eventBus.register("?", "app", toggleIsVisibile);
        return function() {
            return eventBus.unregister("?", "app");
        };
    }, []);
    useEffect(function() {
        var matcher = window.matchMedia("(prefers-color-scheme: dark)");
        // INFO: Needed to apply the color mode for the first time
        applyColorMode();
        matcher.addEventListener("change", function() {
            return applyColorMode();
        });
    }, []);
    var onFontSizeChange = function(newClass) {
        updateFontSize(newClass);
        setCurrFontSize(newClass);
    };
    var onContrastChange = function(newClass) {
        updateContrast(newClass);
        setCurrContrast(newClass);
    };
    var onBgOptionChange = function() {
        if (currBgOption) {
            setCurrBgOption(null);
            updateBackgroundOption(null);
        } else {
            setCurrBgOption("bg--hidden");
            updateBackgroundOption("bg--hidden");
        }
    };
    var onAnimationOptionChange = function() {
        if (currAnimationOption) {
            setCurrAnimationOption(null);
            updateAnimationOption(null);
        } else {
            setCurrAnimationOption("animation--hidden");
            updateAnimationOption("animation--hidden");
        }
    };
    var onLetterSpacingChange = function(newClass) {
        updateLetterSpacing(newClass);
        setCurrLetterSpacing(newClass);
    };
    var onWordSpacingChange = function(newClass) {
        updateWordSpacing(newClass);
        setCurrWordSpacing(newClass);
    };
    var onLineSpacingChange = function(newClass) {
        updateLineSpacing(newClass);
        setCurrLineSpacing(newClass);
    };
    var onColorModeChange = function(newColorMode) {
        updateAndApplyColorMode(newColorMode);
        setColorMode(newColorMode);
    };
    var _useCBookTheme = useCBookTheme(), isAccessibleTheme = _useCBookTheme.isAccessibleTheme, hasColorMode = _useCBookTheme.hasColorMode;
    var isVisible = useSelector(function(state) {
        return state.uiVisibilityState.accessibilityToolbar;
    });
    var quickNav = useSelector(function(state) {
        var _state_cbook;
        return (_state_cbook = state.cbook) === null || _state_cbook === void 0 ? void 0 : _state_cbook.quick_nav;
    });
    var toggleIsVisibile = useCallback(function() {
        dispatch(setUIVisibilityState({
            state: {
                accessibilityToolbar: !isVisible
            }
        }));
    }, [
        dispatch,
        isVisible
    ]);
    var labelFor = useCallback(function(klass) {
        var key = klass.replace(/(--)|(-)/g, "_");
        return intl.formatMessage({
            id: "accessibility.".concat(key),
            defaultMessage: key
        });
    }, [
        intl
    ]);
    return /*#__PURE__*/ React.createElement(UIModal, {
        id: "accessibility-toolbar",
        isVisible: isVisible,
        onClose: toggleIsVisibile,
        title: intl.formatMessage({
            id: "accessibility.title",
            defaultMessage: "Acccessibility Toolbar"
        })
    }, /*#__PURE__*/ React.createElement("section", {
        className: "app-ally-modal__section section-font"
    }, isAccessibleTheme ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h2", {
        className: "app-ally-modal__section-header"
    }, intl.formatMessage({
        id: "accessibility.text_options",
        defaultMessage: "Font"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "app-ally-modal__section section-text-size"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "app-ally-modal__section-title"
    }, intl.formatMessage({
        id: "accessibility.font_size",
        defaultMessage: "Font size"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "app-ally-modal__actions"
    }, FONT_CLASSES.map(function(c) {
        return /*#__PURE__*/ React.createElement(ClassSwitcher, {
            key: c,
            actionClass: c,
            activeClass: currFontSize,
            label: labelFor(c),
            onClick: function() {
                return onFontSizeChange(c);
            }
        });
    })))) : null), /*#__PURE__*/ React.createElement("section", {
        className: "app-ally-modal__section section-graphics"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "app-ally-modal__section-header"
    }, intl.formatMessage({
        id: "accessibility.graphics_options",
        defaultMessage: "Graphics"
    })), hasColorMode ? /*#__PURE__*/ React.createElement("div", {
        className: "app-ally-modal__section section-color-modes"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "app-ally-modal__section-title"
    }, intl.formatMessage({
        id: "accessibility.light_dark_theme",
        defaultMessage: "Appearance"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "app-ally-modal__color-modes"
    }, COLOR_MODES.map(function(c) {
        return /*#__PURE__*/ React.createElement(ColorModeSwitcher, {
            key: c,
            colorMode: c,
            onClick: function() {
                return onColorModeChange(c);
            },
            selectedColorMode: currColorMode
        });
    }))) : null, isAccessibleTheme ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "app-ally-modal__section section-contrast-colors"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "app-ally-modal__section-title"
    }, intl.formatMessage({
        id: "accessibility.color_contrast",
        defaultMessage: "Color contrast"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "app-ally-modal__actions"
    }, CONTRAST_CLASSES.map(function(c) {
        return /*#__PURE__*/ React.createElement(ClassSwitcher, {
            key: c,
            actionClass: c,
            activeClass: currContrast,
            label: labelFor(c),
            onClick: function() {
                return onContrastChange(c);
            }
        });
    })), /*#__PURE__*/ React.createElement("div", {
        className: "app-ally-modal__no-bg"
    }, /*#__PURE__*/ React.createElement("input", {
        type: "checkbox",
        "aria-labelledby": "no-bg-switch",
        checked: currBgOption === "bg--hidden",
        onChange: onBgOptionChange
    }), /*#__PURE__*/ React.createElement("span", {
        id: "no-bg-switch"
    }, intl.formatMessage({
        id: "accessibility.no_bg",
        defaultMessage: "Remove background images"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "app-ally-modal__no-animations"
    }, /*#__PURE__*/ React.createElement("input", {
        type: "checkbox",
        "aria-labelledby": "no-animation-switch",
        checked: currAnimationOption === "animation--hidden",
        onChange: onAnimationOptionChange
    }), /*#__PURE__*/ React.createElement("span", {
        id: "no-animation-switch"
    }, intl.formatMessage({
        id: "accessibility.no_animations",
        defaultMessage: "Hide animations"
    }))))) : null), /*#__PURE__*/ React.createElement("div", {
        className: "app-ally-modal__section section-shortcuts"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "app-ally-modal__section-header"
    }, intl.formatMessage({
        id: "accessibility.keyboard",
        defaultMessage: "Keyboard Shortcuts"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "app-ally-modal__shortcuts"
    }, /*#__PURE__*/ React.createElement("table", null, /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement(Shortcut, {
        keys: "?",
        description: intl.formatMessage({
            id: "ui.accessibility_toolbar",
            defaultMessage: "Show shortcuts"
        })
    }), /*#__PURE__*/ React.createElement(Shortcut, {
        keys: "q",
        description: intl.formatMessage({
            id: "ui.menu_label",
            defaultMessage: "Menu"
        })
    }), /*#__PURE__*/ React.createElement(Shortcut, {
        keys: "j",
        description: intl.formatMessage({
            id: "ui.prev_slide",
            defaultMessage: "Previous slide"
        })
    }), /*#__PURE__*/ React.createElement(Shortcut, {
        keys: "k",
        description: intl.formatMessage({
            id: "ui.next_slide",
            defaultMessage: "Next slide"
        })
    }))), /*#__PURE__*/ React.createElement("table", null, /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement(Shortcut, {
        keys: "b",
        description: "".concat(intl.formatMessage({
            id: "ui.book_mode",
            defaultMessage: "BOOK-MODE"
        }), " & ").concat(intl.formatMessage({
            id: "ui.story_mode",
            defaultMessage: "STORY-MODE"
        }))
    }), quickNav ? /*#__PURE__*/ React.createElement(Shortcut, {
        keys: "c",
        description: intl.formatMessage({
            id: "quick_favourites.title",
            defaultMessage: "Favourites"
        })
    }) : null, /*#__PURE__*/ React.createElement(Shortcut, {
        keys: "u",
        description: intl.formatMessage({
            id: "bonus_material.title",
            defaultMessage: "Bonus Material"
        })
    }), /*#__PURE__*/ React.createElement(Shortcut, {
        keys: "i",
        description: intl.formatMessage({
            id: "social.notes.title",
            defaultMessage: "Notes"
        })
    }), /*#__PURE__*/ React.createElement(Shortcut, {
        keys: "o",
        description: intl.formatMessage({
            id: "ui.activity_center",
            defaultMessage: "Activity Center"
        })
    }))), /*#__PURE__*/ React.createElement("table", null, /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement(Shortcut, {
        keys: "p",
        description: intl.formatMessage({
            id: "ui.toggle_play",
            defaultMessage: "Toggle play"
        })
    }), /*#__PURE__*/ React.createElement(Shortcut, {
        keys: "f",
        description: intl.formatMessage({
            id: "ui.toggle_fullscreen",
            defaultMessage: "Toggle fullscreen"
        })
    }), /*#__PURE__*/ React.createElement(Shortcut, {
        keys: "m",
        description: intl.formatMessage({
            id: "ui.toggle_mute",
            defaultMessage: "Toggle mute"
        })
    }))))));
};
export default injectIntl(AccessibilityToolbar);
